<footer class="footer" id="contact" *ngIf="content$ | async as data">
  <div class="container footer__grid">
    <div class="footer__brand">
      <div style="background-color: white; border-radius: 12px; padding: 12px; display: inline-block; margin-bottom: 16px; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
        <img [src]="getLogoUrl(data.home)" alt="The Husk Bakery" style="height: 48px; object-fit: contain; mix-blend-mode: multiply; display: block;">
      </div>
      <p>{{ data.home?.announcement || 'Artisanal sourdough and handcrafted pastries, baked fresh daily in the heart of Australia.' }}</p>
    </div>
    
    <div class="footer__info">
      <h3>Location</h3>
      <p *ngIf="data.location?.address">{{ data.location.address }}</p>
      <p *ngIf="!data.location?.address">123 Artisan Lane<br>Melbourne, VIC 3000</p>
      
      <p class="mt-sm"><a [href]="'mailto:' + (data.location?.email || 'hello@thehuskbakery.com.au')">{{ data.location?.email || 'hello@thehuskbakery.com.au' }}</a></p>
      <p><a [href]="'tel:' + (data.location?.phone || '(03) 5550 0123')">{{ data.location?.phone || '(03) 5550 0123' }}</a></p>
    </div>

    <div class="footer__hours">
      <h3>Hours</h3>
      <ul *ngIf="data.location?.hours && data.location.hours.length > 0">
        <li *ngFor="let h of data.location.hours"><span>{{ h.day }}:</span> {{ h.time }}</li>
      </ul>
      <ul *ngIf="!data.location?.hours || data.location.hours.length === 0">
        <li><span>Mon - Fri:</span> 6:30 AM - 3:00 PM</li>
        <li><span>Saturday:</span> 7:00 AM - 2:00 PM</li>
        <li><span>Sunday:</span> Closed</li>
      </ul>
    </div>
  </div>
  
  <div class="footer__bottom">
    <div class="container text-center">
      <p>&copy; 2026 The Husk Bakery. All rights reserved.</p>
    </div>
  </div>
</footer>

